import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast, Center, HStack, Spinner, Text } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

import { calTotal } from "../states/cartActions";
import { useStore } from "../states/useStore";
import { cartReset } from "../states/cartActions";
import { customerNameUpdate } from "../states/customerActions";
import { constructCashOrder, orderAdd } from "../states/ordersActions";
import { useOrderCashCreate } from "../states/useRemoteStates";

import useAuth from "../services/useAuth";

const warningToast = (toast) => (message) => {
  toast({
    title: message,
    status: "warning",
    duration: 5000,
    isClosable: true,
    position: "top-right",
  });
};

const CashButton = () => {
  const authInfo = useAuth();

  const toast = useToast();
  const warning = warningToast(toast);

  const navigate = useNavigate();

  const cart = useStore((state) => state.cart);

  const [submit, setSubmit] = useState(false);

  const orderCreate = useOrderCashCreate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  // const terminalCheckout = useCreateTerminalCheckout();

  const handleChkout = (e) => {
    if (cart.length === 0) return;
    onOpen();
  };

  const handleConfirmCash = () => {
    if (submit) return;
    setSubmit(true);
    toast.closeAll();

    const order = constructCashOrder({ locId: authInfo.auth.location, cart });
    if (order instanceof Error) {
      setSubmit(false);
      warning(order.message);
      return;
    }

    // post order to server
    orderCreate.mutate(order, {
      onSuccess: ({ data }) => {
        // save the order returning from server
        orderAdd(data);
        cartReset();
        customerNameUpdate("");
      },
      onError: console.error, // to be send error message
      onSettled: () => {
        // delay enable checkout button
        setTimeout(() => {
          onClose();
          setSubmit(false);
          navigate("/");
        }, 1000);
      },
    });
  };

  return (
    <>
      <Center
        cursor="pointer"
        borderRadius="5"
        fontWeight="600"
        color="white"
        h="60px"
        w="50%"
        p="2"
        bg={submit || cart.length === 0 ? "gray" : "green.700"}
        onClick={handleChkout}
      >
        <HStack>
          {submit && <Spinner />}
          <Text fontSize="1.2rem">
            {submit ? "Wait for cash... " : `CASH $${calTotal(cart)}`}{" "}
          </Text>
        </HStack>
      </Center>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Cash Checkout</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Please wait for a staff to assist you.</ModalBody>
          <ModalFooter>
            <Button
              colorScheme="green"
              mr={3}
              onClick={handleConfirmCash}
              isLoading={submit}
            >
              Staff to Confirm
            </Button>
            <Button variant="ghost" onClick={onClose} disabled={submit}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CashButton;
